import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "orderAttachment",
    serviceName: "auth",
    query: gql`
      query orderAttachment($ids: [String]) {
        orderAttachment(ids: $ids) {
          data {
            title
            details
          }
        }
      }
    `,
  },
  update: {
    name: "updateOrderAttachment",
    serviceName: "auth",
    query: gql`
      mutation updateOrderAttachment(
        $ids: [String]!
        $title: String
        $details: String
      ) {
        updateOrderAttachment(ids: $ids, title: $title, details: $details) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
